import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";
import { HashLink } from "react-router-hash-link";
import { useDispatch, useSelector } from 'react-redux';
import { getBlogs } from '../../../store/actions/blogActions';
//sections
import Layout from "../../Layout.js";
//Components 
import CardBlog from "../../../components/CardBlog.js";


const BlogsPage = () => {
  const dispatch = useDispatch();
  const blogData = useSelector(state => state.blog);

  React.useEffect(() => {
    dispatch(getBlogs());
  }, []);

  return (
    <>
      <div className="main">
        <Layout pages={
          [
            <div
              className="section section-blogs" id="section-blogs" key="section-blogs"
            >
              <Container>
                <h2 className="text-center" style={{ marginBottom: "50px" }}>Bloglarım</h2>
                <HashLink smooth to="/create-blog#create-blog" style={{ color: "#FFF", fontWeight: 600 }}>
                  <Button className="btn-link mr-1 btn btn-warning" style={{ color: "#ee8c1c", marginBottom: "25px" }}>
                    <i className="fa fa-plus"></i> Yeni Blog Oluştur
                  </Button>
                </HashLink>

                {blogData?.blogs?.length > 0 &&
                  <Row>
                    {
                      blogData?.blogs?.map((x) => <Col className="mx-auto" lg="4" md="6" key={`c${x?.id}`}>
                        <CardBlog src={x?.imageURL} id={x?.id} title={x?.title} description={x?.body} isBlog={true} />
                      </Col>)
                    }
                  </Row>
                }
              </Container>
            </div>
          ]
        }></Layout>
      </div>

    </>
  );
}

export default BlogsPage;